import React from 'react';
import PropTypes from 'prop-types';
import css from './CwTreeViewNode.scss';
import CwFlexBox from '../cwflexbox/CwFlexbox';
import CwImage from '../cwimage/CwImage';
import CwLabel from '../cwlabel/CwLabel';
import cx from 'classnames';

const CwTreeViewNode = (props) => {

  const getIcon = () => {
    if (props.children) {
      return (<CwImage className={css.icon} src={props.value.isCollapsed ? props.expandIcon : props.collapseIcon} />);
    }
    else {
      return (<div className={css.icon} />);
    }
  };

  const getLabel = () => {
    return (
      <CwLabel className={cx(css.label, { [css.itemSelected]: props.value.isSelected })} value={props.value.name} />
    );
  };

  const handleClick = () => {
    props.onClick(props.value);
  };

  return (
    <div className={css.wrap}>
      <CwFlexBox
        onClick={handleClick}
        className={css.item}
        verticalAlign>
        {getIcon()}
        {getLabel()}
      </CwFlexBox>
      {props.value.isCollapsed ? null :
        <div className={css.subTree}>
          {props.children}
        </div>}
    </div>
  );
};

export const treeViewNodeShape = {
  /**
   * Id must be unique identifier
   */
  id: PropTypes.string.isRequired,
  /**
   * Rendered text for node
   */
  name: PropTypes.string.isRequired,
  /**
   * Determines if node is selected. Should be mutually exclusive
   */
  isSelected: PropTypes.bool,
  /**
   * Determines if node is collapsed or expanded
   */
  isCollapsed: PropTypes.bool,
};

CwTreeViewNode.propTypes = {
  /**
   * TreeViewNode layout data
   */
  value: PropTypes.shape(treeViewNodeShape).isRequired,
  /**
   * Collapse icon to display when expanded for treeviewnode with children
   */
  collapseIcon: PropTypes.string.isRequired,
  /**
   * Expand icon to display when collapsed for treeviewnode with children
   */
  expandIcon: PropTypes.string.isRequired,
  /**
   * Fires whenever treeviewnode is clicked
   */
  onClick: PropTypes.func.isRequired,
  /**
   * Nested treeviewnodes
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ])
};

export default CwTreeViewNode;


// WEBPACK FOOTER //
// ./src/components/cwtreeview/CwTreeViewNode.jsx